import { render, staticRenderFns } from "./view-student-list.vue?vue&type=template&id=5592a954&scoped=true&"
import script from "./view-student-list.vue?vue&type=script&lang=js&"
export * from "./view-student-list.vue?vue&type=script&lang=js&"
import style0 from "./view-student-list.vue?vue&type=style&index=0&id=5592a954&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5592a954",
  null
  
)

export default component.exports